import CollectionBuilder from './components/CollectionBuilderContainer';
import * as t from './actionTypes';
import * as actions from './actions';
import * as sagas from './sagas';

export { default as catalogCollectionBuilderReducer } from './reducer';
export { t, actions, sagas };

export default CollectionBuilder;
